import React, { useEffect, useState } from "react";

// @mui material components
import Api from "../../Classes/API/UsersApi";
// Material Dashboard 2 React components
import TextField from "@mui/material/TextField";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import Pagination from "@mui/material/Pagination";
import { useNavigate } from "react-router-dom";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Button from "@mui/material/Button";
import MDInput from "components/MDInput";
// Material Dashboard 2 React example components
import Swal from "sweetalert2";
import { useContext } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SearchEmployeeTypes from "../../Classes/Models/Requests/Administration/Employees/SearchEmployeeTypes";
import DeleteEmployeeTypes from "../../Classes/Models/Requests/Administration/Employees/DeleteEmployeeTypes";
import { useLocation, NavLink } from "react-router-dom";
import CardHeader from "@mui/material/CardHeader";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Icon } from "@mui/material";
import { LanguageContext } from "App";
import MDButton from "components/MDButton";
import "./Employestylestylee.scss";
import Loader from "Loader";
const EmployeeTypeList = () => {
  let searchModel = new SearchEmployeeTypes();
  let deleteModel = new DeleteEmployeeTypes();
  const { translations } = useContext(LanguageContext);
  const [EmployeeTypes, SetEmployeeTypes] = useState([]);
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);
  const [IsLoaded, SetIsLoaded] = useState(false);
  const navigate = useNavigate();
  function handleOnClick(url) {
    navigate(url, { replace: true }), [navigate];
  }

  useEffect(() => {
    SetIsLoaded(false);
    fetchEmployeeTypes(searchModel);
    SetIsLoaded(true);
  }, ["default"]);

  // const handleChangePage = (
  //   event: React.MouseEvent<HTMLButtonElement> | null,
  //   newPage: number,

  // ) => {
  //   console.log(newPage)
  //   setPage(newPage);
  // };

  useEffect(async () => {
    console.log(Page);

    await onSearch();
  }, [Page]);

  async function onSearch() {
    SetIsLoaded(false);
    console.log("s");
    let searchModel = new SearchEmployeeTypes();
    // searchModel.id = document.getElementById('id').value;
    searchModel.typeName = document.getElementById("name").value;
    searchModel.standardHourlyRate = document.getElementById("horlyrate").value;
    searchModel.PagingParams.pageNumber = Page;
    Api.SearchEmployeeTypes(searchModel).then((result) => {
      console.log(result);
      SetEmployeeTypes(result.data.list);
      setPaginationPages(result.data.totalPages);
      SetIsLoaded(true);
    });
  }

  async function fetchEmployeeTypes(searchModel) {
    Api.SearchEmployeeTypes(searchModel).then((result) => {
      console.log(result);
      SetEmployeeTypes(result.data.list);
      setPaginationPages(result.data.totalPages);
    });
  }

  async function deleteEmployeeType(id) {
    deleteModel.searchInt = id;
    await Swal.fire({
      title: "Confirm delete ?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.DeleteEmployeeTypes(deleteModel).then((result) => {
          result.status == "Success"
            ? Swal.fire("Deleted!", "", "success")
            : Swal.fire("Not deleted , Unknown error Occured!");
          fetchEmployeeTypes(searchModel);
        });
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  }

  return (
    <div>
      <DashboardLayout>
        {/* Page Title */}
        <DashboardNavbar />

        {/* Search form */}
        <div className="card mt-3">
          <div className="card-body">
            <CardHeader className="mb-2" title={translations.EmployeeTypeTitle}></CardHeader>
            <div className="container-fluid ">
              <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
                <div className="row">
                  <div className="col-md-6">
                    <MDInput
                      className="full-width"
                      id="name"
                      label={translations.EmployeeTypeEmployeetypename}
                      fullWidth
                    />
                  </div>

                  <div className="col-md-6">
                    <TextField
                      className="full-width"
                      id="horlyrate"
                      label={translations.EmployeeTypeEmployeeTypeHourlyRate}
                      type="number"
                      fullWidth
                    />
                  </div>
                </div>

                <div className="text-right mt-3 ">
                  <Button
                    className="white"
                    sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                    size="medium"
                    onClick={onSearch}
                  >
                    {translations.usrBalanceEnteriesSearch}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!IsLoaded && <Loader />}
        {IsLoaded && (
          <div className="card mt-5">
            <MDBox
              mx={2}
              mt={-5}
              py={3}
              px={2}
              bgColor="info"
              sx={{ backgroundColor: "#3560AD" }}
              borderRadius="lg"
              coloredShadow="info"
            >
              <div className="employe-type-btn">
                <MDTypography variant="h6" color="white" mt={1}>
                  <span>{translations.EmployeeTypetableEmployeeTypes} </span>
                </MDTypography>
                <Button
                  sx={{ backgroundColor: "#4682B4", "&:hover": { backgroundColor: "#B0DFE5" } }}
                  className="white float-right"
                  color="primary"
                  variant="contained"
                  size="medium"
                  component={NavLink}
                  to="/createEmployeeType"
                >
                  {translations.EmployeeTypetableCreateEmployeeType}
                </Button>
              </div>
            </MDBox>

            <div className="card-body">
              <div className="container-fluid">
                <table className="table ">
                  <thead>
                    <tr>
                      <th scope="col">{translations.sessionWithoutEnteriesid}</th>
                      <th scope="col">{translations.EmployeeTypetableStandardHourlyRate}</th>
                      <th scope="col">{translations.EmployeeTypetableTypename}</th>
                      <th scope="col">{translations.EmployeeTypetableedit}</th>
                      <th scope="col">{translations.EmployeeTypetabledelete}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {EmployeeTypes.map((Employee) => {
                      return (
                        <tr key={Employee.id}>
                          <th scope="row">{Employee.id}</th>
                          <th scope="row">{Employee.standardHourlyRate}</th>
                          <th scope="row">{Employee.typeName}</th>
                          <th scope="row">
                            <MDTypography
                              onClick={handleOnClick.bind(this, "/editEmployeeType/" + Employee.id)}
                              component="a"
                              variant="button"
                              color="text"
                              fontWeight="medium"
                            >
                              <Icon>settings</Icon>
                            </MDTypography>
                          </th>
                          <th scope="row">
                            <MDButton
                              onClick={deleteEmployeeType.bind(this, Employee.id)}
                              sx={{ backgroundColor: "#333333" }}
                              color="dark"
                            >
                              <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                            </MDButton>
                          </th>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="text-right mx-3 my-4">
                  <Pagination
                    count={PaginationPages}
                    color="primary"
                    onChange={(e, number) => setPage(number)}
                    className="float-right"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </DashboardLayout>
    </div>
  );
};

export default EmployeeTypeList;
